export default "__VITE_ASSET__DKhy3NeW__"